export function isAxiosTransportError(error) {
    if (!error) {
        return false;
    }
    if (
        error.code === "ERR_CANCELED" ||
        error.__CANCEL__ ||
        error.name === "CanceledError"
    ) {
        return false;
    }
    const code = error.code;
    const message = error.message || "";
    return (
        code === "ERR_NETWORK" ||
        code === "ECONNABORTED" ||
        code === "ETIMEDOUT" ||
        message === "timeout exceeded" ||
        /^timeout of \d+ms exceeded$/.test(message)
    );
}

/**
 * Webpack-dev-server's overlay listens on bubble phase and ignores
 * preventDefault. Capture + stopImmediatePropagation keeps aborted /
 * timed-out XHRs from blocking the panel with a red overlay.
 */
export function silenceAxiosTransportOverlay() {
    if (typeof window === "undefined") {
        return;
    }
    window.addEventListener(
        "unhandledrejection",
        (event) => {
            if (isAxiosTransportError(event.reason)) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        },
        true
    );
}
